import React from "react";
import { Link } from "react-router-dom";

import stylesgfi from "./NationalSchoolGames.module.css";
import Breadcrumb from "../../components/common/Breadcrumb";
// import Button from "react-bootstrap/Button";
import { Button, Container, Row, Col } from "react-bootstrap";
import useBWKLSchedule from "./hooks/useBWKLSchedule";
import MatchScheduleCard from "./modules/MatchScheduleCard";

// import Athlite from "./Athlite";

export default function BiharWomenKabaddiMatchScheduleE2() {
  const [schedule] = useBWKLSchedule({ endpoint: "https://bssa-json-server-vercel-deployment.vercel.app/bwkl-e2" });
  return (
    <>
      <Breadcrumb
        pageName={BiharWomenKabaddiMatchScheduleE2}
        pageTitle={"BiharWomenKabaddiMatchScheduleE2"}
        img_url={"/img/BWKLE2-Desktop.jpeg"}
        mobile_banner="/img/BWKLE2-Mobile.jpeg"
      />
      <div></div>
      <div>
        <h1 className={`${stylesgfi.title}`}>
          द्वितीय बिहार महिला कबड्डी लीग 2026{" "}
          <Link to="/matchfixture">मैच शेड्यूल</Link>
        </h1>
      </div>

      <div className={`container`}>
        {/* match schedule cards */}
        {/* some sample data */}
        {/* <MatchScheduleCard 
          matchNumber="Match 1"
          teamA="Team A"
          teamB="Team B"
          time="10:00 AM"
          date="2023-10-10"
        />
        <MatchScheduleCard 
          matchNumber="2"
          teamA="Team C"
          teamB="Team D"
          time="10:00 AM"
          date="2023-10-10"
        /> */}
        <div className="row">
          {(schedule || []).map((match) => (
            <div className="col-md-6">
              <MatchScheduleCard
                key={match.matchNumber}
                matchNumber={match.matchNumber}
                teamA={match.teamA}
                teamALogo={match.teamALogo || "/img/कबड्डी.png"}
                teamB={match.teamB}
                teamBLogo={match.teamBLogo || "/img/कबड्डी.png"}
                time={match.time}
                date={match.date}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
